export default {
}



// WEBPACK FOOTER //
// ./src/store/modules/global/getters.js